import { useTranslation } from 'react-i18next'
import tableCoinIcon from 'assets/images/coin.svg'
import Table from 'components/Table'
import { createColumnHelper } from '@tanstack/react-table'
import { Button } from 'react-bootstrap'
import { useState } from 'react'
import friendStatus from 'assets/images/invite-friend-status.svg'
import CreateRoomModal from 'components/Modal/CreateRoomModal'
import avaDefault from 'assets/images/ava-default.jpeg'
import { useQuery } from 'react-query'
import { getFriendQuery } from 'dataLayer/game'
import { getUserQuery } from 'dataLayer/user'

function FriendTable() {
	const { t } = useTranslation()

	const { data: friends, isLoading } = useQuery(getFriendQuery())
	const { data: user } = useQuery(getUserQuery())

	const [modalInvite, setModalInvite] = useState(false)
	function openInviteModal() {
		setModalInvite(true)
	}
	function closeInviteModal() {
		setModalInvite(false)
	}

	const columnHelper = createColumnHelper()
	const columns = [
		columnHelper.accessor('info', {
			cell: info => {
				const userInfo = info?.row?.original
				return (
					<div className="friend-info">
						<div className="friend-info__ava">
							<img
								src={userInfo?.image ?? avaDefault}
								onError={e => {
									e.target.onerror = null
									e.target.src = avaDefault
								}}
								alt="Friend's avatar"
							/>
							{userInfo?.status === 1 ? (
								<img src={friendStatus} alt="Friend's status" />
							) : null}
						</div>
						<p>{userInfo?.full_name ?? userInfo?.msisdn}</p>
					</div>
				)
			},
			header: () => <span>{t('friendpage.name')}</span>,
			footer: info => info.column.id,
		}),
		// columnHelper.accessor(row => row.coin, {
		// 	id: t('friendpage.gold'),
		// 	cell: info => {
		// 		return (
		// 			<div className="betcoin-container">
		// 				<img src={tableCoinIcon} width="20" alt="Bet's coin" />
		// 				<p>{new Intl.NumberFormat('lo').format(info.getValue())}</p>
		// 			</div>
		// 		)
		// 	},
		// 	header: () => <span>{t('friendpage.gold')}</span>,
		// 	footer: info => info.column.id,
		// }),
		columnHelper.accessor('status', {
			cell: info => {
				return (
					<Button
						disabled={info?.row?.original?.status === 0 ? true : false}
						onClick={openInviteModal}
					>
						{t('friendpage.invite')}
					</Button>
				)
			},
			header: () => null,
			footer: info => info.column.id,
		}),
	]

	return (
		<>
			<Table
				{...{
					data: !isLoading && user ? friends : [],
					columns,
				}}
				friendTable={true}
				friendTableMobile={true}
			/>
			<CreateRoomModal
				show={modalInvite}
				onHide={closeInviteModal}
				title={t('friendpage.invite_play')}
				friendPage={true}
				friendMobile={false}
			/>
		</>
	)
}

export default FriendTable
